import { createI18n } from "vue-i18n";
import { getInitialAppLocale } from "@/utils/appLocaleConstants";

import esJson from "./locales/es.json";
import enJson from "./locales/en.json";
import frJson from "./locales/fr.json";
import deJson from "./locales/de.json";
import ptJson from "./locales/pt.json";

const loadLocaleMessages = () => {
  const convertJsonArrayToObject = (jsonArray) => {
    const result = {};
    if (Array.isArray(jsonArray)) {
      jsonArray.forEach((item) => {
        const key = item["Data Name"] || item["Data name"];
        if (key && item["Value"]) {
          result[key] = item["Value"];
        }
      });
    }
    return result;
  };

  return {
    es: convertJsonArrayToObject(esJson),
    en: convertJsonArrayToObject(enJson),
    fr: convertJsonArrayToObject(frJson),
    de: convertJsonArrayToObject(deJson),
    pt: convertJsonArrayToObject(ptJson),
  };
};

const i18n = createI18n({
  locale: getInitialAppLocale(),
  fallbackLocale: "es",
  legacy: false,
  messages: loadLocaleMessages(),
  missingWarn: false,
  fallbackWarn: false,
});

export default i18n;
